import CheckFriendsReferralInfo from './check-friends-referral-info.container';

export default CheckFriendsReferralInfo;
